module.exports = __webpack_public_path__ + "media/images/icons/payment-methods/security-code-b30b01af23641ca89ba7d65f78970e40.svg";